import * as React from 'react'

export const PlayButton = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.2864 25.6961L17.06 39.5876C15.7279 40.4202 14 39.4625 14 37.8916V10.1087C14 8.5378 15.7279 7.58011 17.06 8.41267L39.2864 22.3041C40.5397 23.0875 40.5397 24.9128 39.2864 25.6961Z"
        fill="#0070E0"
      />
    </svg>
  )
})

PlayButton.displayName = 'CommunityIcon'
